import React, { useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
import { PropertyType } from 'esa-ui-library/lib/types';

import styles from './ActionCurrency.module.scss';
import { useStore } from '../../../../../common';
import { Select } from 'esa-ui-library';

type ValueType = {
	label: string;
	value: string;
};

const ActionCurrency = (): JSX.Element => {
	const [state, dispatch] = useStore();
	const { reports, selectedTotal } = state;
	const [filterOptions, setFiltersOptions] = useState<ValueType[]>([{ label: 'Grand Total', value: 'grand_total' }]);

	const onChange = (option: PropertyType) => {
		dispatch('SELECT_TOTAL', option[0]);
	};

	useEffect(() => {
		if (!isEmpty(reports)) {
			const currenciesOptions = Object.keys(reports).map((c) => ({
				value: c,
				label: c,
			}));
			setFiltersOptions((prevState) => [...prevState, ...currenciesOptions]);
		}
	}, [reports]);

	return (
		<Select
			options={filterOptions}
			multiple={false}
			placeholder='Select language'
			selected={[selectedTotal]}
			dataId='total-field'
			onChange={onChange}
			small
			className={styles.Select}
		/>
	);
};

export { ActionCurrency };
